module.exports = __webpack_public_path__ + "asset/img/error-image.47efa6834ffcf295ab5952f0ba5a9221.png";